import React, { useState, useEffect } from 'react';
import {
  Box,
  Typography,
  Grid,
  Button,
  Skeleton,
} from '@mui/material';
import { useNavigate } from 'react-router-dom';
import SettingPoliciesCard from './SettingPoliciesCard';
import { settingsData } from './SettingsPoliciesData';
import { EnableDisableFeaturesIcon } from '../../../icons';
import { Link } from 'react-router-dom';
const SettingsPolicies = () => {
  const [loading, setLoading] = useState(true);
  const [sections, setSections] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    setTimeout(() => {
      // Filter out "Trending reports" section
      const filteredSections = settingsData.filter(
        (section) => section.title !== 'Trending reports'
      );
      setSections(filteredSections);
      setLoading(false);
    }, 1500);
  }, []);

  return (
    <Box>
      {/* Header */}
      <Box display="flex" justifyContent="space-between" alignItems="center" mb={3}>
        <Typography variant="h6" fontWeight={500} sx={{ fontSize: '24px' }}>
          Settings & Policies
        </Typography>
        <Button
          variant="contained"
          sx={{
            borderRadius: '30px',
            fontWeight: '600',
            display: 'flex',
            alignItems: 'center',
            gap: 1,
            fontSize: '14px',
            padding: '3px 20px',
            background: '#fff',
            color: '#0084FF',
          }}
          onClick={() => navigate('/scheduled-reports')}
        >
          <EnableDisableFeaturesIcon />
          Enable/disable features
        </Button>
      </Box>

      {/* Sections (without Trending reports) */}
      {sections.map((section) => (
        <Box key={section.title} mb={5}>
          <Typography variant="subtitle1" fontWeight={600} mb={2} sx={{ fontSize: '17px' }}>
            {section.title}
          </Typography>
          <Grid
            container
            spacing={2}
            columns={60}
            className="card-body p-20 bg-base border rounded-3"
            sx={{
              display: 'grid',
              gridTemplateColumns: 'repeat(auto-fill, minmax(260px, 1fr))',
              gap: '0rem',
              background: '#fff',
            }}
          >
            {loading ? (
              Array.from({ length: 5 }).map((_, idx) => (
                <Grid item xs={60} sm={30} md={20} lg={12} xl={12} key={idx}>
                  <Skeleton variant="rectangular" height={120} sx={{ borderRadius: 2 }} />
                </Grid>
              ))
            ) : section.items.length === 0 ? (
              <Grid item xs={60}>
                <Typography variant="body1" textAlign="center" py={3}>
                  No data available
                </Typography>
              </Grid>
            ) : (
              section.items.map((item, idx) => (
                <Grid item xs={60} sm={30} md={20} lg={12} xl={12} key={idx}>
                  <Link
                    to={`${item.link}?tab=${idx}`}
                    style={{ textDecoration: 'none', color: 'inherit' }}
                  >
                    <SettingPoliciesCard {...item} />
                  </Link>
                  {/* <SettingPoliciesCard {...item} /> */}
                </Grid>
              ))
            )}
          </Grid>
        </Box>
      ))}
    </Box>
  );
};

export default SettingsPolicies;
